{
  "title": "Invitations",
  "invite": "Invite",
  "dialog": {
    "title": "Invite a member",
    "description": "Send an email invitation to join this school.",
    "role": "Role",
    "email": "Email",
    "emailPlaceholder": "name@example.com",
    "class": "Class",
    "classPlaceholder": "Choose a class",
    "noClasses": "No active classes yet — create one first.",
    "pupil": "Pupil (their child)",
    "pupilPlaceholder": "Choose the pupil",
    "noPupils": "No active pupils to link — invite a pupil first.",
    "submit": "Send invitation",
    "submitting": "Sending…",
    "success": "Invitation sent",
    "failed": "Could not send the invitation"
  },
  "myParent": {
    "title": "Invite a parent or guardian",
    "description": "Add a parent or guardian so they can see your homework, grades and school announcements.",
    "emailLabel": "Their email",
    "submit": "Send the invite",
    "emailRequired": "Type their email address first",
    "sent": "Sent. {{email}} will get a link to join — ask them to check their inbox (and the spam folder).",
    "success": "Invite sent",
    "note": "They join as a parent linked to you, and see only your work — nobody else's."
  },
  "validation": {
    "emailRequired": "Email is required",
    "emailInvalid": "Enter a valid email",
    "classRequired": "Pupil invitations need a class",
    "pupilRequired": "Parent invitations need their child"
  },
  "list": {
    "filterLabel": "Status",
    "all": "All",
    "empty": "No invitations yet.",
    "emptyFiltered": "No invitations with this status.",
    "table": {
      "email": "Email",
      "role": "Role",
      "target": "For",
      "invitedBy": "Invited by",
      "status": "Status",
      "expires": "Expires"
    },
    "resend": "Resend",
    "resent": "Invitation resent",
    "revoke": "Revoke",
    "revokeTitle": "Revoke this invitation?",
    "revokeDescription": "The emailed link stops working. You can invite this person again later.",
    "revoked": "Invitation revoked"
  },
  "status": {
    "pending": "Pending",
    "accepted": "Accepted",
    "revoked": "Revoked",
    "expired": "Expired"
  },
  "landing": {
    "title": "You're invited",
    "invitedBy": "{{name}} invited you to join {{school}}.",
    "roleLabel": "You'll join as",
    "classLabel": "Class",
    "emailNote": "This invitation was sent to {{email}}.",
    "emailMismatch": "You're signed in with a different email than the one invited, so the invitation can't be accepted. Sign in with the invited email or ask for a new invitation.",
    "accept": "Accept invitation",
    "accepting": "Accepting…",
    "accepted": "Welcome to {{school}}!",
    "decline": "Not now",
    "invalidTitle": "This invitation isn't valid",
    "invalidText": "The link is invalid, expired, or was already used. Ask the school to send you a new one.",
    "goHome": "Go to dashboard",
    "checking": "Checking the invitation…"
  }
}
